import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import AdminDashboard from "./components/AdminDashboard";
import Institutions from "./components/Institutions";
import InstitutionDetails from "./components/InstitutionDetails";
import AddInstitution from "./components/AddInstitution";
import AddEnquiry from "./components/AddEnquiry";
import Users from "./components/Users";
import Profile from "./components/Profile";
import AddUser from "./components/AddUser";
import AddPackages from "./components/AddPackages";
import AllPackages from "./components/AllPackages";
import Hotels from "./components/Hotels";
import Properties from "./components/Properties";
import AddHotel from "./components/AddHotel";
import Transportations from "./components/Transportations";
import AddTransportation from "./components/AddTransportation";
import Addons from "./components/Addons";
import AddAddons from "./components/AddAddons ";
import AddItinerary from "./components/Itinerary/AddItinerary";
import AllItinerary from "./components/Itinerary/AllItinerary";
import AssignedInstitution from "./components/AssignedInstitution";
import EditAssignedInstitution from "./components/EditAssignedInstitution";
import ItenaryViewLog from "./components/Itinerary/ItenaryViewLog";
import PackageViewLogs from "./components/PackageViewLogs";
import EnquiryViewLogs from "./components/EnquiryViewlogs";
import ItineraryPreview from "./components/ItineraryPreview";
import HomepageCMS from "./components/HomepageCMS";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Layout from "./layout";
import PrivateRoute from "./route/PrivateRoute";
import PublicRoute from "./route/PublicRoute";
import LoaderComponent from "./components/LoaderComponent";
import { get } from "./utils/api";

const PUBLIC_PATHS = ["/login", "/forgot-password", "/reset-password", "/view/package/", "/view/trip/", "/privacy-policy"];

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [authChecked, setAuthChecked] = useState(false);

  // ✅ SINGLE auth check on app load
  useEffect(() => {
    const checkSession = async () => {
      try {
        await get("/api/me"); // HttpOnly cookie auto sent
      } catch {
        localStorage.removeItem('user');
        const isPublic = PUBLIC_PATHS.some((p) => location.pathname.startsWith(p));
        if (!isPublic) {
          navigate("/login", { replace: true });
        }
      } finally {
        setAuthChecked(true);
      }
    };

    checkSession();
  }, [navigate]);

  // ⏳ Block rendering until auth is checked
  if (!authChecked) {
    return <LoaderComponent />;
  }

  return (
    <Routes>
      {/* PUBLIC ROUTES */}
      <Route path="/login" element={<PublicRoute element={Login} />} />
      <Route
        path="/forgot-password"
        element={<PublicRoute element={ForgotPassword} />}
      />
      <Route
        path="/reset-password/:optionalParam"
        element={<ResetPassword />}
      />

      {/* PUBLIC PREVIEW ROUTES */}
      <Route path="/view/package/:id/:slug" element={<ItineraryPreview type="package" />} />
      <Route path="/view/trip/:id/:slug" element={<ItineraryPreview type="itinerary" />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />

      {/* PRIVATE ROUTES */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />

        <Route path="dashboard" element={<PrivateRoute element={AdminDashboard} />} />
        <Route path="institutions" element={<PrivateRoute element={Institutions} />} />
        <Route path="institution-details" element={<PrivateRoute element={InstitutionDetails} />} />
        <Route path="add-institutions" element={<PrivateRoute element={AddInstitution} />} />
        <Route path="add-enquiry" element={<PrivateRoute element={AddEnquiry} />} />
        <Route path="users" element={<PrivateRoute element={Users} />} />
        <Route path="profile" element={<PrivateRoute element={Profile} />} />
        <Route path="add-user" element={<PrivateRoute element={AddUser} />} />
        <Route path="add-packages" element={<PrivateRoute element={AddPackages} />} />
        <Route path="all-packages" element={<PrivateRoute element={AllPackages} />} />
        <Route path="hotels" element={<PrivateRoute element={Hotels} />} />
        <Route path="add-hotel" element={<PrivateRoute element={AddHotel} />} />
        <Route path="properties" element={<PrivateRoute element={Properties} />} />
        <Route path="transportation" element={<PrivateRoute element={Transportations} />} />
        <Route path="add-transportation" element={<PrivateRoute element={AddTransportation} />} />
        <Route path="addons" element={<PrivateRoute element={Addons} />} />
        <Route path="add-addons" element={<PrivateRoute element={AddAddons} />} />
        <Route path="add-itinerary" element={<PrivateRoute element={AddItinerary} />} />
        <Route path="all-itinerary" element={<PrivateRoute element={AllItinerary} />} />
        <Route path="assigned-institution" element={<PrivateRoute element={AssignedInstitution} />} />
        <Route path="edit-assigned-institution" element={<PrivateRoute element={EditAssignedInstitution} />} />
        <Route path="itinerary-view-logs/:itinerarydetailsid" element={<PrivateRoute element={ItenaryViewLog} />} />
        <Route path="package-view-logs/:packagedetailsid" element={<PrivateRoute element={PackageViewLogs} />} />
        <Route path="enquiry-view-logs/:enquiryid" element={<PrivateRoute element={EnquiryViewLogs} />} />
        <Route path="homepage-cms" element={<PrivateRoute element={HomepageCMS} />} />
      </Route>
    </Routes>
  );
}


export default App;
